import { useSelector, useDispatch } from 'react-redux';

import ItemPrice from 'common/components/item/ItemPrice';
import { getCartTitle } from 'common/helpers/miscHelper';
import Image from 'products/components/Image';
import { addCartItem } from 'redux/cart/actions';

const CartCarrotProduct = (props) => {
  const { product } = props;
  const dispatch = useDispatch();
  const settings = useSelector((state) => state.setting);

  const variant = product?.variants?.[0];

  if (!product || !variant) {
    return null;
  }

  const analytics = {
    viewType: 'Cart Carrot'
  };

  const addToCart = () => {
    const item = {
      quantity: 1,
      sku: variant.sku
    };

    dispatch(addCartItem(item, analytics));
  };

  const title = getCartTitle(settings);

  return (
    <div className="c7-cart__cart-carrot_product">
      <Image
        product={product}
        displayType="List"
        width="40"
        size="small"
        hasLink={false}
      />
      <div className="c7-cart__cart-carrot_product_title">
        <strong>{product.title}</strong>
        <div className="c7-cart__cart-carrot_product_subtitle">
          {variant.title}
        </div>
        <button className="c7-button-small" type="button" onClick={addToCart}>
          Add to {title}
        </button>
      </div>
      {variant && <ItemPrice item={variant} settings={settings} />}
    </div>
  );
};

export default CartCarrotProduct;
